
import React, { Component } from 'react'
import { Link } from 'react-router'
import GenericEvent from './GenericEvent'

const NPS_ICON_SRC = require('images/svg/nps-navy.svg')

export default class NPSCampaignEvent extends Component {
  render() {
    const { campaign } = this.props.event.body
    const eventProps = {
      iconSrc: NPS_ICON_SRC,
      eventLabel: 'submitted an NPS response',
      ...this.props
    }
    return (
      <GenericEvent {...eventProps }>
        <Link to={`/campaigns/${campaign.id}`}>{campaign.name}</Link>
      </GenericEvent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/customer/TimeLine/NPSResponseEvent.js